import React from "react";
import cx from "classnames";
import styles from "./LinksBlock.module.scss";
export const LinksBlock = ({ title, titleLink, links, onClick, }) => {
    const targetBlankParams = {
        rel: "noreferrer noopener",
        target: "_blank",
    };
    return (<div className={styles.linksBlock}>
      {title && (<p className={styles.title}>
          <a className={styles.titleLink} href={titleLink}>
            {title}
          </a>
        </p>)}
      {(links === null || links === void 0 ? void 0 : links.length) ? (<ul className={styles.list}>
          {links === null || links === void 0 ? void 0 : links.map(({ linkUrl, openInNewTab, title, className, id }, i) => (<li key={linkUrl}>
              <a onClick={() => onClick === null || onClick === void 0 ? void 0 : onClick(links[i])} className={cx(styles.link, className)} id={id} href={linkUrl} {...(openInNewTab ? targetBlankParams : {})}>
                {title}
              </a>
            </li>))}
        </ul>) : null}
    </div>);
};
